import React from "react";

/**
 * 🎯 Placeholder only — "Request Sustina Roles" is a separate, unspecified
 * feature (out of scope for the Company Representative flow). Wired here so
 * the dashboard tile has somewhere to go without pretending the feature exists.
 */
export default function SEC_RequestRolesPlaceholder() {
  return (
    <div className="page-main mt-5 pt-5">
      <div className="page-main-inner container">
        <div className="row justify-content-center">
          <div className="col-xl-7 text-center">
            <h2 className="h4 fw-bold mb-2">Request Sustina Roles</h2>
            <p className="text-muted small">Coming soon.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
